import { User, Circle, ArrowRight } from 'react-feather'

export default [
  {
    id: 'user',
    title: 'User',
    icon: <User size={20} />,
    resource: 'User',
    children: [
      {
        id: 'list',
        title: 'List',
        icon: <ArrowRight size={12} />,
        navLink: '/user/list',
        resource: 'User'
      }
    ]
  }
]
